import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const REMARK_PLUGINS = [remarkGfm];

/**
 * Converts a markdown string to an HTML string using react-markdown + remark-gfm.
 * Produces the same output quality as the chat message renderer.
 *
 * @param {string} markdown
 * @returns {string} HTML string
 */
export function markdownToHtml(markdown) {
  if (!markdown || typeof markdown !== 'string') return '';

  try {
    return renderToStaticMarkup(
      createElement(ReactMarkdown, { remarkPlugins: REMARK_PLUGINS }, markdown),
    );
  } catch {
    return markdown;
  }
}
